<nav class="nav d-md-flex align-items-center d-none" style="margin-left: 30px; transform: translateY(70px);">
  <a class="nav-link " routerLink="/busqueda-carpetas">
    <h6 class="m-0">Búsqueda de carpetas</h6>
  </a>
  <i class="fa-solid fa-chevron-right chevron"></i>
  <a class="nav-link" (click)="volverAtras()" style="cursor: pointer">
    <h6 class="m-0">Resultado de la búsqueda</h6>
  </a>
  <i class="fa-solid fa-chevron-right chevron"></i>
  <a class="nav-link">
    <h6 class="m-0">Resumen del crédito</h6>
  </a>
</nav>
<app-main-container header="Resumen del crédito" (clicked)="volverAtras()" [backButton]="true">
  <div class="d-flex header d-md-none mb-3">
    <div class="titulo estado rounded" [style]="{ background: result.semaforo['TBC_COLOR'] }">
      <div [innerHtml]="result.semaforo.ICON | safeHtml" class="icono"></div>
      <div class="titulo border-0">
        <p>Estado actual de la carpeta</p>
        <h5 class="fw-semibold">
          {{ result.estado }}
        </h5>
      </div>
    </div>
  </div>
  <div class="d-flex header">
    <div class="titulo">
      <p>Nombre</p>
      <h5 class="fw-semibold text-uppercase">
        {{ result.nombreCliente }}
      </h5>
    </div>
    <div class="titulo">
      <p>Número de carpeta</p>
      <h5 class="fw-semibold">
        {{ result.numeroCarpeta }}
      </h5>
    </div>
    <div class="titulo monto">
      <p>Monto</p>
      <h5 class="fw-semibold" [ngClass]="result.montoAprobado == '0'? 'text-secondary' : ''">
        {{ result.montoAprobado | currency:'COP':'symbol-narrow':'1.0-0' }}
      </h5>
    </div>
    <div class="titulo estado d-none d-md-block" [style]="{ background: result.semaforo['TBC_COLOR'] }">
      <div [innerHtml]="result.semaforo.ICON | safeHtml" class="icono"></div>
      <div class="titulo border-0">
        <p>Estado actual de la carpeta</p>
        <h5 class="fw-semibold">
          {{ result.estado }}
        </h5>
      </div>
    </div>
  </div>
  <app-tabs-detalle [tabs]="myTabs" [defaultTabIndex]="0" (tabChanged)="onTabChanged($event)"
    style="width: 20px"></app-tabs-detalle>
  <ng-template #generalTemplate>
    <div class="d-md-flex general">
      <div class="w-100 columnas monto">
        <div class="d-flex justify-content-between align-items-center ">
          <div>
            <h5 class="fw-semibold">Tasa interés corriente</h5>
            <p class="subtitle">(N.M.V.: Nominal Mes Vencido)</p>
          </div>
          <p class="text-end">{{ result.tasaAprobadanominal | number : "1.0-2" }}%</p>
        </div>
        <div class="d-flex justify-content-between align-items-center ">
          <div>
            <h5 class="fw-semibold">Tasa interés corriente</h5>
            <p class="subtitle">(E.A.: Efectivo anual)</p>
          </div>
          <p class="text-end">{{ result.tasaAprobadaefectiva | number : "1.0-2"  }}%</p>
        </div>
        <div class="d-flex justify-content-between align-items-center ">
          <div>
            <h5 class="fw-semibold">Tasa interés corriente máxima legal permitida</h5>
            <p class="subtitle">(N.M.V.: Nominal Mes Vencido)</p>
          </div>
          <p class="text-end">{{ result.tasaUsuraMv | number : "1.0-2"  }}%</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Tasa de seguro de vida grupo deudor</h5>
          <p class="text-end">{{ result.seguroVida | number : "1.0-2"  }}%</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold ">Plan póliza seguro de accidentes personales</h5>
          <p class="text-end">{{ result.planSeguroVoluntario | seguroVoluntario }}</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Crédito valor total asegurado</h5>
          <p class="text-end">{{ result.valorsegurodeudor | currency : "COP" : "symbol-narrow" : "1.0-0" }} COP</p>
        </div>
      </div>
      <div class="w-100 columnas">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Comisión por millón</h5>
          <p class="text-end">{{ result.valorMillon | currency : "COP" : "symbol-narrow" : "1.0-0" }} COP</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Monto</h5>
          <p class="text-end"> {{ result.montoAprobadoAnalista | currency : "COP" : "symbol-narrow" : "1.0-0" }} COP
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Plazo</h5>
          <p class="text-end">{{ result.plazoAprobadoAnalista }} Meses</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Cuota</h5>
          <p class="text-end">{{ result.cuotaAprobadaAnalista | currency : "COP" : "symbol-narrow" : "1.0-0" }} COP</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Estudio y administración del crédito</h5>
          <p class="text-end">{{ result.estudioCredito | number : "1.0-2"  }}%</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw-semibold">Pagaduría</h5>
          <p class="text-end">{{ result.pagaduria | capitalize }}</p>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #motorTemplate>
    <table class="table table-striped">
      <tbody>
        <tr *ngFor="let dato of dataSource; let i = index">
          <td class="d-none d-md-table-cell border-0 border-end border-info-subtle p-3">
            <h5 class="fw-semibold">{{ dato.NOMBREPOLITICA }}</h5>
          </td>
          <td class="border-0 p-3">
            <h5 class="fw-semibold d-md-none">{{ dato.NOMBREPOLITICA }}</h5>
            <p class="m-0">{{ dato.RESTRICCION }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-template>
  <ng-template #carteraTemplate>
    <div class="d-flex justify-content-start align-items-start" *ngIf="showAdvertencia">
      <app-advertencias [color]="colorAdvertencia">{{
        textoAdvertencia
        }}</app-advertencias>
    </div>
    <div class="d-md-flex general">
      <div class="w-100 columnas monto">
        <div class="d-flex flex-column justify-content-center" *ngFor="let file of listFiles; let i = index" style="height: auto;">
          <div class="d-flex align-items-center">
            <h5 class="fw-semibold flex-grow-1">{{ file.fileName }}</h5>
            <div
              class="h-100 d-flex justify-content-end align-items-center border-0 border-start border-info-subtle" style="min-width: 108px;">
              <app-hyperlink-icon [icon]="activeIndex === i ? 'close':'plus'" iconPosition="end" (clicked)="toggle(i)">{{activeIndex === i ? 'Cerrar':'Consultar'}}</app-hyperlink-icon>
            </div>
          </div>
          <div [class.show]="activeIndex === i" class="accordion-collapse collapse mt-3" [class.show]="activeIndex === i">
            <div class="accordion-body">
              <section style="width: 100%; background-color: #dbdbdb">
                <section class="d-flex justify-content-end align-items-center p-3 shadow ">
                  <div class="d-flex align-items-center gap-2 border-end border-secondary-subtle px-2">
                    <i class="fa-solid fa-circle-chevron-up" (click)="anteriorPagina()"></i>
                    <i class="fa-solid fa-circle-chevron-down" (click)="siguientePagina()"></i>
                    <p style="
                      padding: 0 !important;
                      margin: 0 !important;
                      font-size: 14px !important;
                    ">
                      Page {{ page }} /
                      {{ pdfViewer?.pdfViewer?.pagesCount }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2 border-end border-secondary-subtle px-2">
                    <i *ngIf="zoom<200" class="fa-solid fa-circle-plus" (click)="masZoom()"></i>
                    <i *ngIf="zoom>10" class="fa-solid fa-circle-minus" (click)="menosZoom()"></i>
                    <p style="
                      padding: 0 !important;
                      margin: 0 !important;
                      font-size: 14px !important;
                    ">
                      Zoom {{zoom}}%
                    </p>
                  </div>
                  <div class="d-flex align-items-center p-2 ms-3">
                    <img src="assets/icons/descargar.svg" alt="" (click)="
                      downloadPDF(
                        'data:application/pdf;base64,' + file.fileBase64,
                        file.fileName
                      )
                    " />
                  </div>
                </section>
                <div style="padding: 3rem">
                  <pdf-viewer [src]="'data:application/pdf;base64,' + file.fileBase64" [render-text]="true"
                    [original-size]="false" [show-all]="false" [page]="page" [zoom]="zoom/100"
                    style="width: 100%; height: 500px"></pdf-viewer>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-template>

  <div class="d-flex flex-column flex-md-row justify-content-between align-items-center m-4"
    *ngIf="selectedTabIndex === 0">
    <div class="retomar mb-4">
      ¿El solicitante no recibió el mensaje o correo para la firma de documentos?
      <app-hyperlink-icon icon="arrow-right" iconPosition="end" [disabled]="isLoading" (clicked)="obtenerUrlAdo()">Haz
        clic aquí</app-hyperlink-icon>
    </div>
    <button-look-feel color="secondary" [loading]="isLoading" (click)="goStep()">Retomar carpeta</button-look-feel>
  </div>
  <br />
</app-main-container>